import React from 'react';
import { AlertCircle, X } from 'lucide-react';

const FEHLER = [
  'Vorschnelle Reparatur ohne Dokumentation',
  'Mündliche Zusagen ohne schriftliche Bestätigung',
  'Fehlende oder zu wenige Fotos vom Unfallort',
  'Unklare Schuldfrage nicht geklärt',
  'Zu spätes Handeln bei der Schadensmeldung'
];

export const TypischeFehler = () => {
  return (
    <section className="py-28 lg:py-36 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Fehler vermeiden
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Häufige Fehler nach einem Unfall
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-normal">
            Diese Fehler können zu späteren Problemen führen
          </p>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-3xl p-10 lg:p-12 shadow-lg">
          <div className="space-y-5">
            {FEHLER.map((fehler, index) => (
              <div key={index} className="flex items-start gap-4 p-5 bg-white border border-gray-100 rounded-2xl hover:border-red-200 hover:shadow-md transition-all">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 bg-red-50 rounded-xl flex items-center justify-center border border-red-100">
                    <X className="w-5 h-5 text-red-500" />
                  </div>
                </div>
                <p className="text-gray-700 leading-relaxed text-[15px] pt-1.5">{fehler}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500 italic">
            Diese Aufstellung dient der Orientierung und stellt keine Rechtsberatung dar.
          </p>
        </div>
      </div>
    </section>
  );
};